import React from 'react';
import { withAuthorization } from '../Session';

import MenuPrincipal from '../../menu/menuPrincipal';
import Rodape from "../../rodape/rodape";

import './index.css';

const HomePage = () => (
  <div>
    <MenuPrincipal />
    <header className="masthead">
      <div className="container h-100">
        <div className="row h-100 align-items-center justify-content-center text-center">
          <div className="col-lg-10 align-self-end">
            <img src="img/logoExpertRedondo.png" />
            <h1 className="text-white font-weight-bold">e<span className="text-verde">X</span>pert Serviços</h1>
            <p className="texto-branco">Orçamento Grátis, Profissionais qualificados, Garantia de 90 dias</p>
            <br /><br />
          </div>
          <div className="col-lg-8 align-self-baseline">
            <a className="btn-destaque" href="/entrar">Solicitar profissional</a>
            <a className="btn-destaque" href="https://api.whatsapp.com/send?phone=5586981817123&text=Olá%20desejo%20um%20atendimento%20personalizado%20para%20minha%20obra">Atendimento personalizado </a>

          </div>

        </div>
      </div>
    </header>

    <section className="page-section bg-primary" id="comentarios">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="text-white mt-0">Comentários</h2>

            <hr className="divider light my-4" />
            <div id="carouselExampleIndicators" className="carousel slide text-white" data-ride="carousel">

              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="row">
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>José Ribamar</b></p>
                      <p><i>"Preço justo e bom serviço. Recomendo"</i></p>
                    </div>
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Aurilene</b></p>
                      <p><i>"Del excelente profissional! Nota mil!"</i></p>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Leandro</b></p>
                      <p><i>"Serviço muito bem executado e no prazo"</i></p>
                    </div>
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Ana</b></p>
                      <p><i>"Bom atendimento e atenção,recomendo"</i></p>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Pedro</b></p>
                      <p><i>"Serviço prestado de ótima qualidade. Bom preço"</i></p>
                    </div>
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Amanda</b></p>
                      <p><i>"Ótimo atendimento"</i></p>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Anderson</b></p>
                      <p><i>"Serviço muito bem executado e no prazo"</i></p>
                    </div>
                    <div className="col">
                      <img src="./img/icon-user.png" height="100" />
                      <p><b>Claudete</b></p>
                      <p><i>"Maravilhoso Recomendo"</i></p>
                    </div>
                  </div>
                </div>
              </div>
              <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
              </a>
              <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section className="page-section" id="Sobre">
      <div className="container">
        <h2 className="text-center mt-0">Sobre</h2>
        <hr className="divider my-4 justify-content-center" />
        <p>Nós somos a eXpert, nós surgimos diante da necessidade e do desafio de milhares de pessoas que possuem diariamente a dificuldade em encontrar um profissional qualificado para resolver seus problemas residenciais, como pequenas reformas ou reparos, problemas com a fiação elétrica, problemas hidráulicos, pinturas entre outros serviços. Diante desse desafio, temos como objetivo facilitar e inovar a busca por profissionais da construção civil pelos clientes que desejam realizar um reparo em casa. Assim, a expert promove a conexão entre as pessoas que precisam de um serviço residencial e os vários profissionais qualificados da construção civil que buscam diariamente pequenas obras e serviços para realizar.</p>
      </div>
    </section>

    <section className="page-section bg-primary">
      <div className="container texto-branco">

        <div className="row">
          <div className="col-sm-12 col-md-3 text-center">
            <img src="img/fotomao.jpg" className="img-fluid" />
          </div>
          <div className="col-sm-12 col-md-9 text-center">
            <h2 className="text-center mt-0">Serviços</h2>
            <hr className="divider my-2" />
            <p>Contrução</p>
            <p>Reforma</p>
            <p>Troca de Piso</p>
            <p>Fiação Eletrica</p>
            <p>Serviços Hidráulicos</p>
            <p>Pintura</p>
            <br /><br /><br />

            <h2 className="text-center mt-0">Atendimento Personalizado</h2>
            <hr className="divider my-2" />
            <p>A eXpert Serviços é parceira de diversas construtoras ao redor do Brasil, caso você tenha interesse em
              orçamentos de serviços de construção ou reparo personalizado, entre em contato conosco através do Whatsapp
          </p>
            <br />
            <a className="btn-destaque-branco" target="_blank"
              href="https://api.whatsapp.com/send?phone=5586981817123&text=Olá%20desejo%20um%20atendimento%20personalizado%20para%20minha%20obra">
              Click aqui para Atendimento Personalizado - eXpert ENGENHARIA</a>
          </div>
        </div>

      </div>
    </section>

    <section className="page-section " id="trabalhe">
      <div className="container">
        <br />
        <div className="row">
          <div className="col-sm-12">
            <h2 className="text-center mt-0">Trabalhe Conosco</h2>
            <hr className="divider my-2" />
            <br /><br />
            <p className="text-center mt-0">Instale o Aplicativo <b>eXpert – Profissionais</b> e
            recba de forma RÁPIDA e SIMPLES ofertas de serviços</p>
            <p className="text-center mt-0">Solicite a aprovação de cadastro</p>
            <p className="text-center mt-0">*Devido à alta demanda, estamos realizando um cadastro de reserva</p>

            <br /><br />
            <p className="text-center">
              <a href="https://play.google.com/store/apps/details?id=br.com.isbrito.expertprofissionais">
                <img src="img/google_play.png" className="img-fluid " />
              </a>
            </p>
          </div>

        </div>
      </div>
    </section>



    <section className="page-section bg-dark text-white" id="contato">
      <div className="container text-center">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="mt-0">Nossos Contatos</h2>
            <hr className="divider my-4" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 ml-auto text-center">
            <img src="./img/whatsapp.png" className="img-fluid" />
            <div>(86) 9 8181-7123</div>
          </div>
          <div className="col-md-3 mr-auto text-center">
            <img src="./img/email.png" className="img-fluid" />
            <div>contato@expertserv.net</div>
          </div>
          <div className="col-md-3 mr-auto text-center">
            <a href="https://www.facebook.com/EXpert-Servi%C3%A7os-345496509401063/" className="link-branco">
              <img src="img/official-facebook-logo.png" className="img-fluid" />
              <div>Facebook</div>
            </a>
          </div>
          <div className="col-md-3 mr-auto text-center">
            <a href="https://www.instagram.com/expert.serv/?hl=pt-br" className="link-branco">
              <img src="img/480px-Instagram_logo_2016.svg.png" className="img-fluid" />
              <div>Instagran</div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <Rodape />

  </div>
);

const condition = authUser => !!authUser;

export default withAuthorization(condition)(HomePage);